import { FC } from 'react';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { TagComponent } from './TagComponent';

export const StatusTag: FC<{ isActive: boolean }> = ({ isActive }) => {
  return (
    <TagComponent
      text={isActive ? 'Active' : 'Inactive'}
      color={isActive ? COLOR.purpel['purpel-6'] : COLOR_CONFIG.red}
    />
  );
};
